import type { KybStatusType } from 'BreetHelpers';

export type IDialogOnboardingTodoListItemStatus = 'pending' | 'get-started' | 'completed';
export interface IDialogOnboardingTodoListItem {
	header: string;
	subHeader: string;
	status: IDialogOnboardingTodoListItemStatus;
	onClick?: () => void;
	isLast?: boolean;
	btnTitle?: string;
	variant?: 'timeline' | 'card';
	locked?: boolean;
	lockedHint?: string;
	rejectionReason?: string;
}

export interface IBreetKybFormTracker {
	completed: boolean;
	active: boolean;
	isLast: boolean;
}

export type IDialogOnboardingTodoListSteps =
	| 'complete-kyb'
	| 'initiate-sandbox'
	| 'first-production-api-key'
	| 'production-webhook-url'
	| 'first-production-transaction'
	| 'mfa-authentication';

export const btnTitleMap: Record<KybStatusType, string> = {
	completed: 'completed',
	pending: 'Under review',
	rejected: 'Update & Resubmit',
	partial: 'Continue',
};

export const kybStatusMap: Record<KybStatusType, IDialogOnboardingTodoListItemStatus> = {
	completed: 'completed',
	pending: 'pending',
	rejected: 'get-started',
	partial: 'get-started',
};
